import React from 'react'
import { LuBrain } from 'react-icons/lu'
import { TbHandStop } from 'react-icons/tb'
import { FaRegHandshake } from 'react-icons/fa'
import { BsClock } from 'react-icons/bs'
import ApproachImg from '../Assets/aaproach.jpg'

const OurApproachContainerData = [
  {
    heading: 'Innovative Curriculum',
    para: 'Develop a dynamic and engaging curriculum that incorporates cutting-edge technologies and teaching methodologies.',
    Icon: LuBrain,
  },
  {
    heading: 'Hands-on Learning',
    para: 'Provide ample opportunities for practical application, project-based learning, and real-world simulations.',
    Icon: TbHandStop,
  },
  {
    heading: 'Industry Partnerships',
    para: 'Collaborate with leading industries to ensure curriculum alignment, provide mentorship opportunities, and facilitate industry exposure.',
    Icon: FaRegHandshake,
  },
  {
    heading: 'Flexible Delivery',
    para: 'Offer a range of learning modalities, including online, blended, and in-person options, to cater to diverse learning styles and preferences.',
    Icon: BsClock,
  },
]

const OurApproach = () => {
  return (
    <section className='home_section'>
      <div className='home_split'>
        <div className='home_split_head'>
          <span className='home_eyebrow'>Our approach</span>
          <h2 className='home_heading'>Innovation, collaboration and student-centric learning</h2>
          <p className='home_lead'>Our approach to education is guided by a commitment to innovation, collaboration, and student-centric learning experiences.</p>
          <div
            className='bento_card bento_image'
            style={{ backgroundImage: `url(${ApproachImg})`, marginTop: 32 }}
            role='img'
            aria-label='Students learning together'
          />
        </div>

        <div className='bento'>
          {OurApproachContainerData.map(({ Icon, heading, para }, index) => (
            <div className='bento_card' key={index}>
              <Icon className='bento_icon' />
              <h3 className='bento_title'>{heading}</h3>
              <p className='bento_para'>{para}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default OurApproach
